/**
 * Shop archive: hero fade-in.
 */
const SELECTORS = {
    hero: '[data-shop-hero]',
};
export function initShopPage() {
    const hero = document.querySelector(SELECTORS.hero);
    if (!hero) {
        return;
    }
    requestAnimationFrame(() => {
        hero.classList.add('is-visible');
    });
}
